/**
 * Checks if none of the values in the first array are present in the second array.
 *
 * @param {string | ReadonlyArray<string>} value The value or array of values to check.
 * @param {ReadonlyArray<any>} arr The array to check against.
 * @returns {boolean} Whether none of the values are in the array.
 */
export const noneIn = (value = "", arr) => {
    // TODO zisti, preco sa tu niekedy dostane null
    if (value === null || typeof value === "string") {
        return !(value !== null && value.length > 0) || !arr.includes(value);
    }
    const values = value.filter(val => val !== "");
    if (values.length === 0 || arr.length === 0) {
        return true;
    }
    return !values.some(v => arr.includes(v));
};
